import SidebarSectionContainerItem from "@Sidebar/components/Sections/SidebarSectionContainerItem";
import React, {ReactNode} from "react";
import FilterSectionTitle from "@SearchResults/features/sidebar/components/FilterSectionTitle";
import {ArrayFilterState} from "@SearchResults/reducers/filterSlice";
import Accordion from "react-bootstrap/Accordion";
import AccordionItem from "@Generic/accordion/AccordionItem";
import FilterToggleableSectionTitle from "@SearchResults/features/sidebar/components/FilterToggleableSectionTitle";

type FilterSectionProps = {
    translationKey: string,
    children: ReactNode,
    isToggleable?: boolean,
    filterDataKey?: keyof ArrayFilterState
    onBlur?: (event) => void,
}

function FilterSection({children, translationKey, isToggleable, filterDataKey, onBlur}: FilterSectionProps) {
    if (isToggleable) {
        return (
            <Accordion className="gb--sidebar-section-content-item">
                <AccordionItem
                    eventKey="filter-item"
                    Header={FilterToggleableSectionTitle}
                    headerProps={{filterDataKey, translationKey}}
                    accordionCollapseProps={{className: "filter__toggleable-content"}}
                    accordionToggleProps={{className: "filter__toggleable-title"}}
                >
                    {children}
                </AccordionItem>
            </Accordion>
        )
    }

    return (
        <SidebarSectionContainerItem>
            <FilterSectionTitle
                filterDataKey={filterDataKey}
                translationKey={translationKey}
            />
            {children}
        </SidebarSectionContainerItem>
    );
}

export default FilterSection;